import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';


const DashCard = ({ title = "Firm Projects", number, svgIcon, redirect }) => {
  const navigate = useNavigate();

  const renderSvg = (svgIcon) => (<img src={svgIcon} style={{ height: '100%' }} />);


  return (
    <Card
      sx={{
        width: 250,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        boxShadow: '0px 1px 8px 0px #0000001F, 0px 3px 4px 0px #00000024, 0px 3px 3px -2px #00000033'
      }}>
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', pl: 4, pt: 3, pb: 1 }}>
        <Box sx={{ height: 60 }}>
          {renderSvg(svgIcon)}
        </Box>
        <div style={{ paddingLeft: 8 }}>
          {number === null ? <CircularProgress /> :
            <Typography component="div" fontWeight={200} fontSize={32}>
              {number}
            </Typography>
          }
          <Typography component="div" fontWeight={700} fontSize={18}>
            {title}
          </Typography>
        </div>
      </CardContent>
      {redirect &&
        <CardActions sx={{ justifyContent: 'flex-end', pt: 0 }}>
          <Button size="small" style={{ textTransform: 'none' }} onClick={() => navigate(redirect)}>
            <ArrowRightAltIcon />
            <span style={{ color: "#012A52", fontWeight: 800, marginRight: '4px' }}>More Info</span>
          </Button>
        </CardActions>
      }
    </Card >
  );
}

export default DashCard;
